import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import API from "../../api/api";
import Modal from "../../components/Modal";
import Toast from "../../components/Toast";
import "./Gallery.css";

const IMG_BASE = "https://cmsapi.mks.org.au/uploads/";

function GalleryList() {
    const [list, setList] = useState([]);
    const [filteredList, setFilteredList] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [loading, setLoading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [formData, setFormData] = useState({
        title: "",
        year: new Date().getFullYear(),
        coverImage: null
    });
    const [toast, setToast] = useState(null);

    const fetchList = () => {
        setLoading(true);
        console.log("Fetching gallery list from /gallery...");
        API.get("/gallery")
            .then(res => {
                console.log("Gallery list received:", res.data);
                setList(res.data);
                setFilteredList(res.data);
            })
            .catch(err => {
                console.error("Error fetching gallery list:", err);
                console.error("Error details:", err.response?.data || err.message);
                setList([]);
            })
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        fetchList();
    }, []);

    useEffect(() => {
        const results = list.filter(x =>
            x.Title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            x.Year?.toString().includes(searchTerm)
        );
        setFilteredList(results);
    }, [searchTerm, list]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const data = new FormData();
            if (formData.coverImage) data.append("coverImage", formData.coverImage);

            const params = new URLSearchParams({
                title: formData.title,
                year: formData.year
            }).toString();

            console.log("Submitting Gallery Payload:", { ...formData });

            await API.post(`/gallery?${params}`, data, {
                headers: { "Content-Type": "multipart/form-data" }
            });

            showToast("Gallery event created successfully");
            setIsModalOpen(false);
            fetchList();
            setFormData({ title: "", year: new Date().getFullYear(), coverImage: null });
        } catch (err) {
            showToast("Error creating gallery event", "error");
        }
    };

    const showToast = (message, type = "success") => {
        setToast({ message, type });
    };

    return (
        <div className="admin-card animate-fade-in">
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "35px", flexWrap: "wrap", gap: "20px" }}>
                <div>
                    <h2 style={{ margin: 0, color: "var(--text-dark)", fontSize: "1.75rem", fontWeight: "800" }}>Gallery Events</h2>
                    <p style={{ margin: "5px 0 0 0", color: "var(--text-muted)", fontSize: "0.9rem" }}>Manage community photo albums and event galleries</p>
                </div>
                <div style={{ display: "flex", gap: "15px", alignItems: "center", flex: 1, justifyContent: "flex-end" }}>
                    <div className="search-container">
                        <span className="search-icon">🔍</span>
                        <input
                            className="form-control"
                            placeholder="Search by title or year..."
                            value={searchTerm}
                            onChange={e => setSearchTerm(e.target.value)}
                        />
                    </div>
                    <button className="btn btn-primary" onClick={() => setIsModalOpen(true)} style={{ height: "45px" }}>
                        + Add Gallery
                    </button>
                </div>
            </div>

            {loading ? (
                <div style={{ textAlign: "center", padding: "100px" }}>
                    <div className="spinner"></div>
                    <p style={{ marginTop: "15px", color: "var(--text-muted)" }}>Loading galleries...</p>
                </div>
            ) : (
                <div className="gallery-grid">
                    {filteredList.map(x => {
                        const imgUrl = x.CoverImage ? (x.CoverImage.startsWith('http') ? x.CoverImage : IMG_BASE + x.CoverImage) : "https://via.placeholder.com/400x300?text=No+Cover";
                        return (
                            <Link key={x.GalleryEventId} to={`/gallery/${x.GalleryEventId}`} className="gallery-card">
                                <div className="gallery-cover-wrapper">
                                    <img src={imgUrl} className="gallery-cover-img" alt={x.Title} />
                                    <span className="year-badge">{x.Year}</span>
                                </div>
                                <div className="gallery-card-content">
                                    <h3 className="gallery-card-title">{x.Title}</h3>
                                    <div className="gallery-card-action">
                                        📁 Manage Photos
                                    </div>
                                </div>
                            </Link>
                        );
                    })}
                </div>
            )}

            <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} title="Create Gallery Event">
                <form onSubmit={handleSubmit} className="premium-form">
                    <div className="form-group">
                        <label>Title (Event-wise categorization)</label>
                        <input className="form-control" value={formData.title} onChange={e => setFormData({ ...formData, title: e.target.value })} required placeholder="e.g., Diwali 2026" />
                    </div>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
                        <div className="form-group">
                            <label>Year</label>
                            <input type="number" className="form-control" value={formData.year} onChange={e => setFormData({ ...formData, year: e.target.value })} required />
                        </div>
                        <div className="form-group">
                            <label>Cover Image</label>
                            <input type="file" className="form-control" onChange={e => setFormData({ ...formData, coverImage: e.target.files[0] })} required />
                        </div>
                    </div>
                    <div style={{ marginTop: "30px", display: "flex", justifyContent: "flex-end", gap: "12px" }}>
                        <button type="button" className="btn btn-outline" onClick={() => setIsModalOpen(false)}>Cancel</button>
                        <button type="submit" className="btn btn-primary">Create Gallery Event</button>
                    </div>
                </form>
            </Modal>

            {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}
        </div>
    );
}

export default GalleryList;